import styled from 'styled-components';

import media from '../../../theme/media';

const getSize = (props) => {
    switch (props.diskSize) {
        case 'x-small':
            return '24px';
        case 'small':
            return '40px';
        case 'fixed-small':
            return '40px';
        case 'large':
            return '80px';
        default:
            return '40px';
    }
};
const getDesktopSize = (props) => {
    switch (props.diskSize) {
        case 'x-small':
            return '24px';
        case 'small':
            return '56px';
        case 'fixed-small':
            return '40px';
        case 'large':
            return '112px';
        default:
            return '56px';
    }
};
const getImgSize = (props) => {
    switch (props.diskSize) {
        case 'x-small':
            return '24px';
        case 'small':
            return props.variant === 'hasBorderedImg' ? '38px' : '40px';
        case 'large':
            return props.variant === 'hasBorderedImg' ? '78px' : '80px';
        default:
            return props.variant === 'hasBorderedImg' ? '38px' : '40px';
    }
};
const getImgDesktopSize = (props) => {
    switch (props.diskSize) {
        case 'x-small':
            return '24px';
        case 'small':
            return props.variant === 'hasBorderedImg' ? '54px' : '56px';
        case 'large':
            return props.variant === 'hasBorderedImg' ? '110px' : '112px';
        default:
            return props.variant === 'hasBorderedImg' ? '54px' : '56px';
    }
};
const getBackground = (props) => {
    switch (props.variant) {
        case 'primary':
            return props.isDisabled ? props.theme.purple_24_tr : props.theme.purple_100;
        case 'secondary':
            return props.isDisabled ? props.theme.white : props.theme.purple_8_tr;
        case 'tertiary':
            return props.isDisabled ? 'transparent' : props.theme.grey_8_lc;
        case 'letterIndex':
            return props.theme.white;
        case 'selectedPassive':
            return props.theme.white_72_tr;
        case 'transparent':
            return 'transparent';
        case 'hasBorderedImg':
            return props.theme.white;
        default:
            return props.theme.white;
    }
};
const getBorder = (props) => {
    if (props.variant !== 'hasBorderedImg' && props.noBorder) {
        return 'transparent';
    } else {
        switch (props.variant) {
            case 'primary':
                return props.isDisabled ? 'transparent' : props.theme.purple_100;
            case 'secondary':
                return props.isDisabled ? props.theme.purple_16_tr : 'transparent';
            case 'tertiary':
                return props.isDisabled ? props.theme.grey_28_tr : props.theme.grey_8_lc;
            case 'letterIndex':
                return props.isDisabled ? props.theme.white : props.theme.black;
            case 'selectedPassive':
                return props.theme.purple_40_tr;
            case 'transparent':
                return 'transparent';
            case 'hasBorderedImg':
                return props.theme.grey_28_tr;
            default:
                return props.theme.white;
        }
    }
};

export const DiskBadgeContainer = styled.span`
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border-radius: 50%;
    width: ${(props) => getSize(props)};
    height: ${(props) => getSize(props)};
    background: ${(props) => getBackground(props)};
    border: ${(props) => (props.variant === 'letterIndex' ? '2px' : '1px')} solid ${(props) => getBorder(props)};
    position: relative;

    ${media.desktop1920} {
        width: ${(props) => getDesktopSize(props)};
        height: ${(props) => getDesktopSize(props)};
    }
`;

export const ImgWrap = styled.span`
    width: ${(props) => getImgSize(props)};
    height: ${(props) => getImgSize(props)};
    flex-shrink: 0;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    opacity: ${(props) => (props.isDisabled ? '0.24' : props.isInactive ? '0.48' : null)};
    overflow: hidden;
    border-radius: ${(props) => (props.withoutRadius ? null : '50%')};

    ${media.desktop1920} {
        width: ${(props) => getImgDesktopSize(props)};
        height: ${(props) => getImgDesktopSize(props)};
    }

    img {
        width: 100%;
        max-width: 100%;
        border-radius: ${(props) => (props.withoutRadius ? null : '50%')};
    }
`;

export const FlagIconWrap = styled.span`
    position: absolute;
    right: -4px;
    bottom: -4px;
    border: 2px solid ${(props) => props.theme.white};
    border-radius: 50%;
    display: inline-flex;
    background: ${(props) => props.theme.white};
    z-index: 1;

    ${media.desktop1920} {
        right: -2px;
        bottom: -2px;
    }
`;
export const FlagIconContainer = styled.span`
    display: inline-flex;
    opacity: ${(props) => (props.isDisabled ? '0.24' : props.isInactive ? '0.48' : null)};
`;
export const SecondFlagIconWrap = styled.span`
    position: absolute;
    right: -14px;
    bottom: -4px;
    border: 2px solid ${(props) => props.theme.white};
    border-radius: 50%;
    display: inline-flex;
    background: ${(props) => props.theme.white};

    ${media.desktop1920} {
        right: -12px;
        bottom: -2px;
    }
`;
